
import React from 'react';
import { LucideIcon, ChevronLeft, ChevronRight } from 'lucide-react';

interface Tab {
  id: string;
  label: string;
  icon: LucideIcon;
}

interface SidebarProps {
  tabs: Tab[];
  activeTab: string;
  setActiveTab: (tabId: string) => void;
  isOpen: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ tabs, activeTab, setActiveTab, isOpen }) => {
  return (
    <>
      {/* Overlay para Mobile */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-slate-900/50 z-40 md:hidden backdrop-blur-sm"
          onClick={() => setActiveTab(activeTab)} // Apenas para disparar o fechamento via lógica do pai se desejar, ou usar uma prop onClose
        />
      )}

      <aside 
        className={`
          fixed md:sticky top-0 left-0 z-50 h-screen transition-all duration-300 bg-white border-r border-slate-200 flex flex-col
          ${isOpen ? 'w-64 translate-x-0' : 'w-0 -translate-x-full md:w-20 md:translate-x-0'}
        `}
      >
        <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
          <nav className="mt-8 flex-1 px-3 space-y-2">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;
              
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`
                    w-full flex items-center p-3 text-sm font-medium rounded-xl transition-all group
                    ${isActive 
                      ? 'bg-indigo-600 text-white shadow-md' 
                      : 'text-slate-600 hover:bg-indigo-50 hover:text-indigo-600'
                    }
                  `}
                  title={!isOpen ? tab.label : undefined}
                >
                  <Icon 
                    className={`flex-shrink-0 ${isOpen ? 'mr-3' : 'mx-auto'} ${isActive ? 'text-white' : 'text-slate-400 group-hover:text-indigo-600'}`} 
                    size={22} 
                  />
                  {isOpen && <span className="truncate font-semibold">{tab.label}</span>}
                </button>
              );
            })}
          </nav>
        </div>
        
        {isOpen && (
          <div className="p-4 border-t border-slate-100">
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center">
              4Nutri v2.1
            </p>
          </div>
        )}
      </aside>
    </>
  );
};

export default Sidebar;
